import { createModel } from "@rematch/core";
import { uniq } from "lodash";
import { ProductType, SupplyType, Tariff, TariffTypesState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, mapSupplyTypes, signoutIfUnauthorized } from "./utilities";

const initialState: TariffTypesState = {
  data: [],
};

export const tariffTypesElectricity = createModel<RootModel>()({
  state: initialState as TariffTypesState,
  reducers: {
    fetchSuccess(state, payload: Tariff[]) {
      return {
        ...state,
        data: payload,
      };
    },
    fetchFail(state) {
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async fetchTariffTypesElectricity(payload: null, rootState) {
      const token = checkToken(rootState, () =>
        dispatch.tariffTypesElectricity.fetchFail()
      );
      if (!token) return;

      try {
        const tariffTypesResult = await api.fetchTariffTypes(
          token,
          ProductType.ELECTRICITY
        );
        const tariffTypes = mapSupplyTypes(tariffTypesResult.data);
        dispatch.tariffTypesElectricity.fetchSuccess(tariffTypes);
        dispatch.supplyTypesMappedToProductFamilies.fetchSuccess({
          [ProductType.ELECTRICITY]: {
            [SupplyType.GV]: uniq(
              tariffTypes
                .filter(
                  (tariff) =>
                    tariff.supplyType === SupplyType.GV && tariff.productFamily
                )
                .map((tariff) => tariff.productFamily)
            ),
            [SupplyType.SV]: uniq(
              tariffTypes
                .filter(
                  (tariff) =>
                    tariff.supplyType === SupplyType.SV && tariff.productFamily
                )
                .map((tariff) => tariff.productFamily)
            ),
          },
        });
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.tariffTypesElectricity.fetchFail();
        dispatch.supplyTypesMappedToProductFamilies.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/tariffTypesElectricity.ts